var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Green_Matters_Logo_copy-01",
    "data-name": "Green Matters Logo copy-01",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.145,
    height: 71.976,
    viewBox: "0 0 71.145 71.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.602,
    x2: 1,
    y2: 0.602,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e5384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0e4d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#0f3c74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#112060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12074f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.062,
    y1: -7.674,
    x2: -5.294,
    y2: -7.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00692b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0db14b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -10.83,
    y1: -6.441,
    x2: -9.064,
    y2: -6.441,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.842,
    y1: -8.993,
    x2: -4.544,
    y2: -10.307,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.077,
    y1: 2.867,
    x2: 0.772,
    y2: 1.884,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.968,
    y1: 2.906,
    x2: 0.336,
    y2: 1.876,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.495,
    y1: 6.34,
    x2: 0.499,
    y2: 5.676,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M70.686,40.832l-6.264-4.611a1.127,1.127,0,0,0-1.795.906V37.4H34.653V4.438A4.333,4.333,0,0,0,30.319.1h0A4.331,4.331,0,0,0,26.4,2.59a17.3,17.3,0,1,0-9.1,32.019,17.211,17.211,0,0,0,8.68-2.34V37.4H18.25c-.313-.017-.629-.027-.944-.027a17.3,17.3,0,1,0,17.3,17.3c0-.462-.024-.918-.06-1.369h.1v-7.24H62.627v.286a1.127,1.127,0,0,0,1.795.908c1.841-1.357,4.659-3.431,6.264-4.611a1.132,1.132,0,0,0,.459-.908A1.121,1.121,0,0,0,70.686,40.832ZM17.3,25.955A8.651,8.651,0,1,1,25.955,17.3,8.655,8.655,0,0,1,17.3,25.955ZM25.993,53.92c0,.255-.01.5-.036.748v0a8.651,8.651,0,1,1-9.165-8.636v.027h9.194V53.3H26A3.533,3.533,0,0,0,25.993,53.92Z",
    transform: "translate(0 0)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M231.327,71.92l-5.757,8.994,3.069.015a13.276,13.276,0,0,0,18.226,9.281l-5.217-.32,2.233-4.056a8.135,8.135,0,0,1-9.874-4.88l2.987.015Z",
    transform: "translate(-186.935 -59.602)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M329.719,48.385,324.875,49a8.122,8.122,0,0,1,1.011,10.88l-1.3-2.37-5.152,9.353,10.659.653L328.5,64.634a13.26,13.26,0,0,0-1.5-20.5Z",
    transform: "translate(-264.719 -36.572)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M258.639,19.189A13.28,13.28,0,0,0,242.15,30.5l2.917-4.556,2.437,3.895a8.152,8.152,0,0,1,7.874-5.928,8.319,8.319,0,0,1,1.017.069l-1.312,2.8,10.594-1.343-5.748-9Z",
    transform: "translate(-200.675 -13.624)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M230.34,84.369l2.633.014.074.332A12.951,12.951,0,0,0,245.52,94.754h.067a12.742,12.742,0,0,0,3.066-.37l-3.717-.228,2.1-3.809a8.511,8.511,0,0,1-1.447.123h-.045a8.578,8.578,0,0,1-7.947-5.479l-.226-.586,2.838.014L235.314,76.6Z",
    transform: "translate(-190.888 -63.48)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M331.826,76.05a12.824,12.824,0,0,0,.85-17.77l1.387,2.172-4.659.591a8.575,8.575,0,0,1,2.16,5.724,8.481,8.481,0,0,1-1.718,5.1l-.4.528L328.2,70.124,323.75,78.2l9.208.563-1.37-2.49Z",
    transform: "translate(-268.299 -48.298)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M264.5,21.6l-1.108,2.367-.344-.087a12.832,12.832,0,0,0-3.131-.4h-.067a12.849,12.849,0,0,0-12.3,9.122l2.033-3.177,2.319,3.706a8.606,8.606,0,0,1,7.946-5.368h.045a8.621,8.621,0,0,1,1.07.072l.581.075-1.231,2.627,9.151-1.16Z",
    transform: "translate(-205.15 -17.9)",
    fill: "url(#linear-gradient-7)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.c80cbeea5b89fb78b1964b66e97d020e.svg";
export { ForwardRef as ReactComponent };